import { Dayjs } from 'dayjs';
import { FC, useCallback, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import TextButton from '@/components/elements/Button/TextButton';
import { RaceProgram } from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';
import { Campaign } from '@/lib/microcms/model';
import { findCampaign, orderByOrderDeadline } from '@/lib/race/singlerace';
import { DayType, RecentRacePrograms } from '@/pages/Top/types';

import RaceBox from './RaceBox';
import {
  ButtonTextWrapper,
  CurrentRaceHeadLine,
  DateSelector,
  EmptyMessage,
  NextIcon,
  PrevIcon,
  RaceList,
} from './style';

interface SingleraceListProps {
  recentRacePrograms?: RecentRacePrograms;
  campaigns: Campaign[];
}

const SingleraceList: FC<SingleraceListProps> = ({
  recentRacePrograms,
  campaigns,
}) => {
  const [date, setDate] = useState<Dayjs>(dayjst());
  const [dayType, setDayType] = useState<DayType>(DayType.Today);

  const handleClick = (type: DayType, _date: Dayjs) => {
    if (dayType === DayType.PreviousDay || dayType === DayType.NextDay) {
      setDayType(DayType.Today);
    } else {
      setDayType(type);
    }
    setDate(_date);
  };

  const getCampaign = useCallback(
    (rp: RaceProgram) => findCampaign(rp, campaigns),
    [campaigns],
  );

  return (
    <div>
      <DateSelector>
        {dayType !== DayType.PreviousDay ? (
          <TextButton
            size={['s', 's', 'm', 'm']}
            hoverEffect="highlight"
            onClick={() =>
              handleClick(DayType.PreviousDay, date.subtract(1, 'day'))
            }
          >
            <ButtonTextWrapper>
              <PrevIcon />
              {dayType === DayType.NextDay ? '開催中' : '前日'}
            </ButtonTextWrapper>
          </TextButton>
        ) : (
          <div />
        )}
        <CurrentRaceHeadLine>
          <h2>
            {dayType === DayType.PreviousDay && '前日'}
            {dayType === DayType.NextDay && '翌日'}
            {dayType === DayType.Today && '開催中'}
            のレース
          </h2>
          <time>{date.format('YYYY年M月D日')}</time>
        </CurrentRaceHeadLine>
        {dayType !== DayType.NextDay ? (
          <TextButton
            size={['s', 's', 'm', 'm']}
            hoverEffect="highlight"
            onClick={() => handleClick(DayType.NextDay, date.add(1, 'day'))}
          >
            <ButtonTextWrapper>
              {dayType === DayType.PreviousDay ? '開催中' : '翌日'}
              <NextIcon />
            </ButtonTextWrapper>
          </TextButton>
        ) : (
          <div />
        )}
      </DateSelector>
      {recentRacePrograms && recentRacePrograms[dayType].length > 0 ? (
        <RaceList>
          {orderByOrderDeadline(recentRacePrograms[dayType]).map(rp => (
            <CSSTransition key={rp.id} timeout={200}>
              <RaceBox raceProgram={rp} campaign={getCampaign(rp)} />
            </CSSTransition>
          ))}
        </RaceList>
      ) : (
        <EmptyMessage>開催がありません</EmptyMessage>
      )}
    </div>
  );
};

export default SingleraceList;
